import React, { useMemo } from "react";
import { includes, isFunction, isNumber, keys, values } from "lodash";
import styled from "styled-components";
import { Platform, getPlatformColor } from "@linkfluence/models/platform";
import _GLYPHS, { Glyph as IconGlyph } from "./glyphs";

export type Glyph = IconGlyph;

export const SIZES = {
  xs: "8px",
  s: "16px",
  ms: "20px",
  m: "24px",
  l: "32px",
};

export const GLYPHS = keys(_GLYPHS);

const StyledIcon = styled.div<{ disk?: boolean; color?: string; size: string }>`
  display: inline-flex;
  vertical-align: middle;
  justify-content: center;
  stroke-width: 0;
  line-height: 0 !important;
  fill: currentColor;
  stroke: currentColor;
  color: ${({ color }) => color};
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  ${(props) =>
    props.disk &&
    `
    background-color: currentColor;
    border-radius: 100%;
  `};
  & + span {
    vertical-align: middle;
  }
  svg {
    height: 100%;
    width: 100%;
    ${(props) =>
      props.disk &&
      `
      transform: scale(${2 / 3});
      fill: #FFF;
      stroke: #FFF;
    `}
  }
`;

interface IProps {
  size?: string | number;
  glyph: Glyph;
  color?: string;
  disk?: boolean;
  className?: string;
  style?: object;
  svg?: string;
  onClick?: any;
}

const UiKitIcon = React.forwardRef(
  (
    { size = "s", glyph, color, disk, className, style, onClick }: IProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const cssSize = useMemo(() => {
      return isNumber(size) ? size + "px" : SIZES[size] || size;
    }, [size]);

    // Automatically apply platform color on platform glyphs, unless color is provided
    const _color = color
      ? color
      : includes(values(Platform), glyph)
      ? getPlatformColor(glyph as Platform)
      : undefined;

    return (
      <StyledIcon
        ref={ref}
        size={cssSize}
        color={_color}
        disk={disk}
        className={className}
        style={style}
        onClick={isFunction(onClick) ? onClick : undefined}
      >
        {_GLYPHS[glyph] && React.createElement(_GLYPHS[glyph])}
      </StyledIcon>
    );
  }
);

export default UiKitIcon;
